import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7zvy8vlx5g: FaireBrandEntity = {
  token: "b_7zvy8vlx5g",
  type: "brand",
  name: "Hellenic Farms",
  avatarUrl:
    "https://cdn.faire.com/fastly/350b7a0b999e57dbf4f1c0c4397f1a89f481fd8557a08132743babfcfa27c12c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5b378c26220c7b855a0256c47a84e934a969a62de79297ee7f2d2d878e5e65b0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/350b7a0b999e57dbf4f1c0c4397f1a89f481fd8557a08132743babfcfa27c12c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5b378c26220c7b855a0256c47a84e934a969a62de79297ee7f2d2d878e5e65b0.jpeg",
  location: "Roselle, NJ, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 41,
  isInsider: true,
  description:
    "Hellenic Farms is a premium importer and supplier of specialty Greek food products.  \nOur journey into all things Greek began when the founder, Vivianna, decided to leave her hectic life in New York City and follow her heart to Greece. \nComing from a lineage of foodies: her paternal grandfather owned the only bodega in the village of Armolia, Xios where surrounding villagers would come to shop, and her maternal grandparents were and still are Mastic farmers, a unique natural resin that only grows on the island of Xios, she always knew that really good, all-natural, traditional food existed in Greece, after all it is where democracy, philosophy & the Olympics began! \n“I have always found it challenging to find great Greek foods at the local grocer, so in 2013 I decided that I would make it my mission to reintroduce the American table to Hellenic products of excellence! “\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:35.965Z",
    importedBy: "entity-db-cli",
  },
};
